import React, { useState } from 'react';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [attempts, setAttempts] = useState(0);
  const [showPass, setShowPass] = useState(false);
  const [expired, setExpired]   = useState(null); // پیام انقضای اعتبار
  const [pendingUser, setPendingUser] = useState(null); // کاربری که بعد از بستن اخطار وارد می‌شود
  const [pendingSession, setPendingSession] = useState(''); // session_token

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/login/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (data.ok) {
        localStorage.setItem('access',  data.access);
        localStorage.setItem('refresh', data.refresh);
        localStorage.setItem('user',    JSON.stringify(data.user));
        localStorage.setItem('session_token', data.session_token || '');
        if (data.expired) {
          // اعتبار تمام شده → پیام
          setPendingUser(data.user);
          setPendingSession(data.session_token || '');
          setExpired(data.expired_msg || 'اعتبار استفاده از برنامه برای شما به پایان رسیده است. جهت تمدید تماس بگیرید.');
        } else {
          onLogin(data.user, data.session_token);
        }
      } else {
        setAttempts(a => a + 1);
        setError(data.msg || 'خطای ورود');
      }
    } catch {
      setError('خطا در اتصال به سرور.');
    } finally {
      setLoading(false);
    }
  };

  const closeExpired = () => {
    setExpired(null);
    if (pendingUser) {
      const u = pendingUser;
      const s = pendingSession;
      setPendingUser(null);
      setPendingSession('');
      onLogin(u, s);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        {/* لوگو */}
        <div style={s.logoRow}>
        <div style={s.logoBox}>
          <img 
            src={require('../assets/images/arjan.png')} 
            alt="ارجان" 
            style={{width:'50px', height:'50px', borderRadius:'10px'}}
          />
        </div>
          <div>
            <div style={s.sysName}>سامانه ارجان</div>
            <div style={s.sysSubtitle}>اداره کل ورزش و جوانان</div>
          </div>
        </div>

        <div style={s.hr}/>
        <div style={s.formTitle}>ورود به سیستم</div>

        <form onSubmit={submit} style={s.form}>
          {/* نام کاربری */}
          <div style={s.field}>
            <label style={s.label}>نام کاربری</label>
            <div style={s.inputRow}>
              <span style={s.ico}>👤</span>
              <input
                type="text" value={username}
                onChange={e => setUsername(e.target.value)}
                style={s.input} placeholder="نام کاربری"
                required dir="ltr" disabled={loading}
              />
            </div>
          </div>

          {/* رمز عبور */}
          <div style={s.field}>
            <label style={s.label}>رمز عبور</label>
            <div style={s.inputRow}>
              <span style={s.ico}>🔒</span>
              <input
                type={showPass ? 'text' : 'password'} value={password}
                onChange={e => setPassword(e.target.value)}
                style={{...s.input, paddingLeft:'38px'}}
                placeholder="رمز عبور" required dir="ltr" disabled={loading}
              />
              <span onClick={() => setShowPass(v => !v)} style={s.eye}>
                {showPass ? '🙈' : '👁️'}
              </span>
            </div>
          </div>

          {/* خطا - افتا الزام ۱: نمایش تعداد تلاش */}
          {error && (
            <div style={s.errBox}>
              <span>⚠️</span>
              <div>
                <div style={s.errMsg}>{error}</div>
                {attempts > 0 && attempts < 5 && (
                  <div style={s.attMsg}>تلاش ناموفق: {attempts} از ۵ — پس از ۵ بار حساب قفل می‌شود</div>
                )}
              </div>
            </div>
          )}

          <button type="submit" style={s.btn} disabled={loading}>
            {loading ? '⏳ در حال بررسی...' : '🔐 ورود به سیستم'}
          </button>
        </form>

        <div style={s.footer}> — نسخه ۱.۱</div>
      </div>

      {/* پاپ‌آپ انقضای اعتبار */}
      {expired && (
        <div style={s.overlay} onClick={closeExpired}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <button onClick={closeExpired} style={s.modalClose} aria-label="بستن">✕</button>
            <div style={s.modalIcon}>⏰</div>
            <div style={s.modalTitle}>پایان اعتبار</div>
            <div style={s.modalMsg}>{expired}</div>
            <button onClick={closeExpired} style={s.modalBtn}>ورود به سیستم</button>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(135deg,#0a1628 0%,#1a2f50 50%,#0d2137 100%)',
    padding: '20px',
  },
  card: {
    background: '#fff', borderRadius: '20px', padding: '38px 34px',
    width: '100%', maxWidth: '410px',
    boxShadow: '0 30px 80px rgba(0,0,0,0.5)',
  },
  logoRow:    { display:'flex', alignItems:'center', gap:'14px', marginBottom:'18px' },
  logoBox:    { width:'54px', height:'54px', background:'linear-gradient(135deg,#1a2f50,#0d2137)', borderRadius:'13px', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 },
  sysName:    { fontSize:'20px', fontWeight:'700', color:'#1a2f50' },
  sysSubtitle:{ fontSize:'11px', color:'#999' },
  hr:         { height:'1px', background:'linear-gradient(to right,transparent,#ddd,transparent)', margin:'18px 0' },
  formTitle:  { fontSize:'14px', fontWeight:'600', color:'#444', textAlign:'center', marginBottom:'20px' },
  form:       { display:'flex', flexDirection:'column', gap:'16px' },
  field:      { display:'flex', flexDirection:'column', gap:'7px' },
  label:      { fontSize:'13px', fontWeight:'600', color:'#444' },
  inputRow:   { position:'relative', display:'flex', alignItems:'center' },
  ico:        { position:'absolute', right:'13px', fontSize:'15px', pointerEvents:'none' },
  input:      { width:'100%', padding:'11px 42px 11px 14px', border:'2px solid #e8e8e8', borderRadius:'10px', fontSize:'14px', fontFamily:'inherit', background:'#fafafa', outline:'none' },
  eye:        { position:'absolute', left:'12px', cursor:'pointer', fontSize:'15px', userSelect:'none' },
  errBox:     { display:'flex', gap:'10px', alignItems:'flex-start', background:'#fff8f8', border:'1.5px solid #ffcdd2', borderRadius:'10px', padding:'11px 13px' },
  errMsg:     { fontSize:'13px', color:'#c62828', fontWeight:'500', marginBottom:'3px' },
  attMsg:     { fontSize:'11px', color:'#e65100' },
  btn:        { padding:'13px', background:'linear-gradient(135deg,#1a2f50,#2a4a7f)', color:'#fff', border:'none', borderRadius:'10px', fontSize:'15px', fontWeight:'700', fontFamily:'inherit', cursor:'pointer', boxShadow:'0 4px 18px rgba(26,47,80,0.35)' },
  footer:     { textAlign:'center', marginTop:'22px', paddingTop:'14px', borderTop:'1px solid #f0f0f0', fontSize:'11px', color:'#bbb' },

  // پاپ‌آپ انقضا
  overlay:    { position:'fixed', inset:0, background:'rgba(10,22,40,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999, padding:'20px' },
  modal:      { position:'relative', background:'#fff', borderRadius:'16px', padding:'34px 30px 28px', width:'100%', maxWidth:'380px', textAlign:'center', direction:'rtl', boxShadow:'0 30px 80px rgba(0,0,0,0.5)' },
  modalClose: { position:'absolute', top:'12px', left:'14px', border:'none', background:'none', fontSize:'20px', color:'#999', cursor:'pointer', lineHeight:1 },
  modalIcon:  { fontSize:'46px', marginBottom:'12px' },
  modalTitle: { fontSize:'17px', fontWeight:'700', color:'#c62828', marginBottom:'10px' },
  modalMsg:   { fontSize:'14px', color:'#444', lineHeight:'1.9' },
  modalBtn:   { marginTop:'20px', padding:'11px 0', width:'100%', background:'linear-gradient(135deg,#1a2f50,#2a4a7f)', color:'#fff', border:'none', borderRadius:'10px', fontSize:'14px', fontWeight:'700', fontFamily:'inherit', cursor:'pointer' },
};